"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Save = function Save() {
  return _react2.default.createElement(
    "g",
    { id: "save" },
    _react2.default.createElement("path", {
      d: "M388.890004,3.60752695e-06 L55.5600036,3.60752695e-06 C40.8229489,-0.00530417426 26.6879614,5.84661739 16.2672894,16.2672894 C5.84661739,26.6879614 -0.00530417426,40.8229489 3.60752695e-06,55.5600036 L3.60752695e-06,444.440004 C-0.00530417426,459.177058 5.84661739,473.312046 16.2672894,483.732718 C26.6879614,494.15339 40.8229489,500.005311 55.5600036,500.000004 L444.440004,500.000004 C475.088469,499.912122 499.912122,475.088469 500.000004,444.440004 L500.000004,111.110004 L388.890004,3.60752695e-06 Z M250.000004,444.440004 C203.978115,444.440004 166.670004,407.131892 166.670004,361.110004 C166.670004,315.088115 203.978115,277.780004 250.000004,277.780004 C296.021892,277.780004 333.330004,315.088115 333.330004,361.110004 C333.359247,383.219446 324.589253,404.431753 308.955503,420.065503 C293.321753,435.699253 272.109446,444.469247 250.000004,444.440004 L250.000004,444.440004 Z M333.330004,166.660004 L55.5600036,166.660004 L55.5600036,55.5600036 L333.330004,55.5600036 L333.330004,166.660004 Z",
      id: "Shape"
    })
  );
};

exports.default = Save;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Save.js
// module id = 2982
// module chunks = 4